<template>
  <v-app id="app" class="app unselectable-text">
    <Navbar />

    <v-content :class="isMobile ? 'ma-1' : 'ma-3'">
      <router-view />
    </v-content>
    <v-navigation-drawer v-model="drawer" fixed temporary right width="400px">
      <portal-target name="sidebar">
        <!--
        This component can be located anwhere in your App.
        The slot content of the above portal component will be rendered here.
        -->
      </portal-target>
    </v-navigation-drawer>
    <v-snackbar
      v-model="snackbarShowing"
      :timeout="5000"
      bottom
      :color="snackbar.color"
    >
      <span>{{ snackbar.text }}</span>
      <v-btn color="white" flat @click="snackbarShowing = false">Close</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import Navbar from './components/Navbar'
import { InternshipsSpecialty } from './models/Content'
import specialtyFetcher from './mixins/specialtyFetcher'

export default {
  name: 'App',
  components: { Navbar },
  mixins: [specialtyFetcher],
  data() {
    return {
      drawer: false,
    }
  },
  mounted() {
    this.$root.$on('drawer', (value) => {
      this.drawer = value
    })
  },
  computed: {
    snackbarShowing: {
      set(show) {
        this.$store.dispatch('displaySnackbar', show)
      },
      get() {
        return this.$store.getters.snackbar.show
      }
    },
    snackbar() {
      return this.$store.getters.snackbar
    },
    user(){
      return this.$store.getters.user
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
  },
  methods: {
    async internshipspecialties() {
      await Promise.all([
        InternshipsSpecialty.fetch().catch(err =>
          this.$store.dispatch(
            'showErrorSnackbar',
            err.message || 'Error getting Internships conditions'
          )
        ),

        this.fetchSpecialtyIfEmpty().catch(err =>
          this.showErrorSnackbar(err.message || 'Something went wrong')
        )
      ])
    }
  },
  watch: {
    user(newUser, old){
      if(old === null && newUser !== null){
        this.internshipspecialties()
      }
    } 
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Lexend+Deca:wght@100;200;500;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Ubuntu:wght@300;400;700&display=swap');
.unselectable-text {
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
}
#app {
  font-family: 'Ubuntu', sans-serif;
  background-color: #4eba6f10;
}
.application {
  font-family: 'Ubuntu', sans-serif;
}

.headline,
.title,
.subheading,
.daterangepicker{
     font-family: 'Ubuntu', sans-serif !important;
}

html {
  overscroll-behavior-y: contain;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(82, 80, 80, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar {
  width: 12px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(216, 210, 210, 0.918);
  background-color: rgb(190, 190, 190);
}

.logo {
  height: 60px;
  width: auto;
}

.relative {
  position: relative;
}

.v-btn--active {
  background-color: #4caf50 !important;
  border-color: #4caf50 !important;
  color: white !important;
}

table.statsTable {
  border-collapse: collapse;
  width: 100%;
}

table.statsTable td,
table.statsTable th {
  white-space: nowrap;
  border: 1px solid white !important;
  /* text-align: left; */
  padding: 8px;

  text-align: center;
  vertical-align: middle;
}

table.statsTable th {
  color: white;
  font-weight: normal;
}

table.statsTable tr {
  background-color: #dddddd;
}

table.statsTable .odd {
  background-color: #b4b4b4 !important;
}

table.statsTable .even {
  background-color: #dddddd !important;
}
.thin-border.v-text-field--outline>.v-input__control>.v-input__slot {
    border: 1px solid #bbbbbb !important;
    border-radius: 10px;
}
.thin-border.v-btn-toggle--selected,
.thin-border.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
    border: 1px solid #bbbbbb !important;
    border-radius: 10px;
    box-shadow: none;
    overflow: hidden;
}
.dense.v-text-field.v-text-field--solo .v-input__control {
    min-height: initial !important;
}
.v-messages__message {
  color: red !important;
}

.v-treeview-node__content,
.v-treeview-node__label {
  flex-shrink: 1 !important;
}
.v-treeview-node__content {
  align-items: start !important;
}
.v-treeview-node__root {
  height: auto !important;
  margin-top: 5px !important;
  margin-bottom: 5px !important;
  align-items: start !important;
}
.v-treeview-node--leaf {
  margin-left: 0px !important;
}
.v-treeview-node__children .v-treeview-node--leaf {
  margin-left: 26px !important;
}

/* Border Colors */
.border {
  border: 1px solid;
}

.grey--border {
  border-color: rgb(204, 204, 204) !important; 
}

/* Cards */
.card-rounded {
  border-radius: 10px !important;
}

</style>
